import { createFileRoute } from '@tanstack/react-router';
import ReservationsPage from '../../../../pages/ReservationsPage';

export const Route = createFileRoute('/_authenticated/$owner/reservations/')({
  component: ReservationsPage
});
